import { Callout, Flex,Text } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import { useGetStudentMyAssessmentsQuery } from "../../hooks/useGetAssessmentsQuery";
import { useGetStudentClassesQuery } from "../../hooks/useGetStudentClassesQuery";
import { useGetTeacheIdByUserId } from "../../hooks/useGetTeacheIdByUserId";
import { RootState } from "../../redux/store";
import { useGetLessonPlansQuery } from "../../hooks/useGetLessonPlansQuery";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import { LessonPlanDocumentType, LessonPlanType } from "../../types/LessonPlan";
import { routes } from "../../routes";
import { EyeOpenIcon, Pencil1Icon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { formatDateForInput } from "../../utils/dateFormatter";
import toast from "react-hot-toast";
import lessonPlan, { setLessonPlanData } from "../../redux/slices/school/lessonPlan";
import { getLessonPlansDocuments } from "../../services/school/lessonPlans/getLessonPlans";
import { useGetAssignedTeachersClassesSubjectsQuery } from "../../hooks/useGetAssignedTeachersClassesSubjectsQuery";


const columnNamesMap: { [key: string]: string } = {
    subject:"Disciplina", 
   // class:"Turma", 
    dateDisplay:"Data", 
    objectives:"Objectivos", 
    resources:"Recursos", 
    activities:"Actividades", 
  };
export const ClassLessonPlans = () => {
    const { UserId } = useSelector((state: RootState) => state.login.userData)
    const { data: studentData } = useGetTeacheIdByUserId(UserId, {enabled: !!UserId});
    const {data: studentClasses, isLoading: isLoadingStudentClasses, isError: isErrorStudentClasses} = useGetStudentClassesQuery({PageNumber:1, PageSize:100, IdStudent:studentData?.idStudent }, {enabled: !!studentData?.idStudent})
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { control, setValue, getValues, formState: { errors }, watch, trigger, reset } = useForm({
      defaultValues:{ idClass:'', idSubject:'', idSubjectTemp:''},
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
  });
  const {data: lessonPlans, isLoading: isLoadingLessonPlans, status:statusLessonPlans, refetch: refreshLessonPlans} = useGetLessonPlansQuery({PageNumber:1, PageSize:100, IdClass:getValues('idClass'), IdSubject:getValues('idSubject') }, {enabled: !!studentData?.idStudent && !!getValues('idClass')})

  const { data: classSubjectTeachers, isLoading: isLoadingClassSubjectTeachers, isError: isErrorClassSubjectTeachers, refetch: refreshClassSubjectTeacher } = useGetAssignedTeachersClassesSubjectsQuery(
    { PageNumber: 1, PageSize: 400, IdClass: getValues('idClass') },
    {
        enabled: !!getValues('idClass')
    }
)
  const handleClassChange = (idClass:string)=> {
    setValue('idClass', idClass);
    refreshLessonPlans();
  }
  const handleSubjectChange = (idSubject:string)=> {
    setValue('idSubjectTemp', idSubject);
    setValue('idSubject', idSubject.split('/')?.[0]);
    refreshLessonPlans();
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handlePreview = async (lessonPlan: LessonPlanType) => {
    try {
        const {items} = await getLessonPlansDocuments({PageNumber:1, PageSize:100, IdLessonPlan: lessonPlan.id})
        if(items.length>0){
          const documents = items?.map((document: LessonPlanDocumentType) => {
            return {
                ...document,
            };
        });
        lessonPlan.documents = documents
      }
        lessonPlan.description = lessonPlan.description??"";
        dispatch(setLessonPlanData(lessonPlan))
        navigate(routes.previewLessonPlan)
        
      } catch (error) {
        toast.error("Não foi possivel realizar o seu pedido")
      } 
  };
  const handleClickBack = async () => {
    navigate(routes.dashboard)
  };
  const options = lessonPlans?.items.map(() => [
    {
      label: 'Visualizar',
      onClick: (s: LessonPlanType) => handlePreview(s),
      icon: <EyeOpenIcon />
    },

    // {
    //   label: 'Imprimir',
    //   onClick: (s: LessonPlanType) => handlePrint(s),
    //   icon: <ArchiveIcon />
    // },

  ]) || [];


  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Text>
            Entre como estudante &nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Text>
        </Callout.Root>

      </Flex>
    );
  }
  return (
    <>
    <Flex direction='column' gap='4'>
        <Flex gap='4'>
              <SelectComponent
                  label="Turma"
                  options={studentClasses?.items.map((sc) => ({
                      value: sc.idClass,
                      label: sc.class ?? ""
                  }))}
                  errors={errors}
                  control={control}
                  itemsError={isErrorStudentClasses}
                  itemsLoading={isLoadingStudentClasses}
                  name={"idClass"}
                  onSelect={handleClassChange}
                  style={{ width: '100%' }}

              />
           <SelectComponent
                        label="Disciplina"
                        options={classSubjectTeachers?.items.map((sc, index) => ({
                            value:`${sc.idSubject}/${index}`,
                            label: `${sc.teacher} | ${sc.subject}`
                        }))}
                        errors={errors}
                        control={control}
                        itemsError={isErrorClassSubjectTeachers}
                        itemsLoading={isLoadingClassSubjectTeachers}
                        name={"idSubjectTemp"}
                        onSelect={handleSubjectChange}
                        style={{ width: '100%' }}
                    />

        </Flex>
        <Lists
                status={statusLessonPlans}
                TableComponent={() =>
                  <TableComponent
                    columns={Object.keys(columnNamesMap)}
                    items={lessonPlans?.items.map(i=>{
                      return {...i, dateDisplay:formatDateForInput(i.date!)}
                    })}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={lessonPlans?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                }
              //  handleClickCreate={handleClickCreate}
              // handleClickBack={handleClickBack}
              />

    </Flex>
  </>
  )
}
